module.exports = __webpack_public_path__ + "static/media/izlozba (14).b4c9ebc8.jpg";